import { HeartHandshake, PhoneOff, ShieldCheck, Users, Rocket, FileText, Store } from "lucide-react";
import { Reveal } from "./Reveal";

const reasons = [
  { icon: HeartHandshake, title: "Consulenza gratuita", desc: "Ti ascoltiamo e ti guidiamo senza costi e senza impegno." },
  { icon: PhoneOff, title: "Nessun call center", desc: "Parli sempre con persone reali, direttamente in negozio." },
  { icon: ShieldCheck, title: "Assistenza prima e dopo", desc: "Ti seguiamo anche dopo l'acquisto, per qualsiasi necessità." },
  { icon: Users, title: "Più operatori disponibili", desc: "Confrontiamo tutti i gestori per la scelta migliore." },
  { icon: Rocket, title: "Attivazioni rapide", desc: "Pratiche gestite velocemente, senza attese inutili." },
  { icon: FileText, title: "Preventivi personalizzati", desc: "Soluzioni cucite sulle tue reali esigenze e sul tuo budget." },
  { icon: Store, title: "Supporto in negozio", desc: "Un punto di riferimento fisico, vicino a te a Torino e Moncalieri." },
];

export const WhyUs = () => (
  <section id="perche-noi" data-testid="why-us-section" className="bg-[#FAFAFA] py-24 md:py-32 border-y border-neutral-100">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-brand">Perché sceglierci</p>
        <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl">
          Perché i clienti ci scelgono
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {reasons.map((r, i) => (
          <Reveal key={r.title} delay={(i % 3) * 0.06}>
            <div data-testid={`why-card-${i}`} className="group h-full rounded-3xl bg-white border border-neutral-100 p-8 hover:border-brand/30 hover:shadow-xl hover:shadow-black/5 transition-[border-color,box-shadow] duration-300">
              <div className="w-14 h-14 rounded-2xl bg-ink group-hover:bg-brand flex items-center justify-center transition-colors duration-300">
                <r.icon className="w-7 h-7 text-white" strokeWidth={1.5} />
              </div>
              <h3 className="font-display font-semibold text-xl mt-6">{r.title}</h3>
              <p className="mt-2 text-neutral-500 leading-relaxed">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
